import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Route, Router } from "@angular/router";
import { TranslocoService } from "@jsverse/transloco";
import { RestService } from "@stdoutsrl/design-kit"
import { Message } from "@stdoutsrl/design-kit";
import { LoaderService } from "../../service/loader.service";

@Component({
  selector: "app-user-rank",
  templateUrl: "./user-rank.component.html",
  styles: [],
  standalone: false,
})
export class UserRankComponent {

  constructor() {}

  @Input() position :number = 0
  @Input() score :number = 0
  @Input() icon :string = '😇'
  @Input() nickname :string = '?'
  @Input() last:boolean = false
  @Input() customClass:string = ''

}
